import "core-js/modules/es.array.at.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.map.get-or-insert.js";
import "core-js/modules/es.map.get-or-insert-computed.js";
import "core-js/modules/es.string.at-alternative.js";
import Cookies from "js-cookie";
import { throttle } from "lodash";
import { monthStartAndEdn, weekStartAndEnd } from "@/utils/util";
import OpenAppModal from "@/views/OpenApp.vue";
import UnitSelect from "@/views/MGT/AppList/UnitSelect.vue";
import { getVisibleFavoriteIds, normalizeFavorites, toggleFavorite } from "@/utils/favorites";
import { getMgtViewIsBig, setMgtViewIsBig } from "@/utils/mgt-view-mode";
import TextEllipsis from "@/components/Common/text-ellipsis.vue";
import WeekInDetail from "@/views/MGT/modal/WeekInDetail";
import WeekInAreaChars from "@/views/MGT/modal/WeekInAreaChars";
import draggable from "vuedraggable";
import { openApp } from "@/libs/common";
import { getUnitInfo } from "@/service/unit";
// eslint-disable-next-line no-unused-vars
import { loginCountTop10, version } from "@/service/log";
import { generateFwhlAuthCode } from "@/service/help";
import { getAppList, editCustomAppOrder, getCurrentAppFavorites, saveCurrentAppFavorites } from "@/service/appList";
import { mapState } from "vuex";
import dayjs from "dayjs";
// 统计周期用于弹窗标题，week/month 对应中文文案。
const STATISTIC_LABEL = {
  week: $t("go81", "周"),
  month: $t("kco1", "月")
};
const defaultImg = "data:image/svg+xml;charset=UTF-8,%3Csvg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='48' height='48' rx='12' fill='%23785a1a'%3E%3C/rect%3E%3Cpath d='M24 10l2.4 5.6L32 18l-5.6 2.4L24 26l-2.4-5.6L16 18l5.6-2.4L24 10z' fill='%23fff8f1'%3E%3C/path%3E%3Ccircle cx='33' cy='32' r='2.5' fill='%23fff8f1' opacity='0.9'%3E%3C/circle%3E%3Ccircle cx='16' cy='34' r='1.5' fill='%23fff8f1' opacity='0.6'%3E%3C/circle%3E%3Cpath d='M14 24c-1.5 1-2.5 2.8-2.5 4.8' stroke='%23fff8f1' stroke-width='1.5' stroke-linecap='round' opacity='0.5'%3E%3C/path%3E%3C/svg%3E";
import wrzImg from "@/assets/MGT/wrz@2x.png";
import shzImg from "@/assets/MGT/shz@2x.png";
import wtgImg from "@/assets/MGT/wtg@2x.png";
import yrzImg from "@/assets/MGT/yrz@2x.png";

/** Desired display order for app groups (by code) */
const GROUP_CODE_ORDER = ["CLOUDLINK_PIVOT", "OPERA", "OPEN_PLATFORM"];

/** Fallback name-based ordering for groups without a known code */
const GROUP_NAME_ORDER = [$t("aj27qo4", "云链星枢"), $t("aj27pp4", "云链星板"), "Oracle Hospitality", $t("dcqx8p6", "绿云内部应用"), $t("avu6on4", "内部应用"), $t("cenafv4", "开放平台"), $t("c9jbtj4", "平台产品"), $t("byuefr4", "客房产品"), $t("blkwmy4", "基础服务"), $t("cfbwgu4", "应用集成")];
export default {
  name: "MGT",
  components: {
    TextEllipsis,
    WeekInDetail,
    WeekInAreaChars,
    draggable,
    UnitSelect,
    OpenAppModal
  },
  data() {
    return {
      active: "ALL",
      allGroups: [],
      groupedApps: {},
      // { [groupId: string]: app[] }
      favorites: [],
      favoriteApps: [],
      backendFavoriteCount: 0,
      isFavoriteSaving: false,
      searchKeyword: "",
      isAppListLoaded: false,
      isBigFlex: getMgtViewIsBig(),
      defaultImg,
      // Unit / stats (keep for modal handlers)
      unit: {
        approvedStatus: {
          icon: "ios-information-circle",
          text: $t("fsi133", "未认证"),
          color: "#8490A2"
        }
      },
      statisticType: "week",
      listTop10: [],
      fwhlCode: "",
      showAppMarketTooltip: true,
      showFadeLeft: false,
      showFadeRight: false
    };
  },
  computed: {
    ...mapState({
      user: state => state.user,
      unitCategoryMap: state => state.app.unitCategoryMap,
      language: state => state.app.language,
      isMobile: state => state.app.isMobile
    }),
    isAdmin() {
      let {
        unitId,
        isAdmin
      } = this.$store.state.user.userInfo;
      return unitId ? isAdmin === "T" : false;
    },
    shouldShowAppMarketTooltip() {
      return !this.isMobile && this.showAppMarketTooltip;
    },
    identityInfo() {
      let {
        userInfo: {
          isAdmin,
          isFounder
        }
      } = this.user;
      let userInfo = JSON.parse(JSON.stringify(this.user.userInfo));
      if (isFounder === "T") {
        userInfo.identity = $t("chspy3", "创建者");
      } else if (isAdmin === "T") {
        userInfo.identity = $t("io38z3", "管理员");
      } else {
        userInfo.identity = $t("aan4n54", "企业成员");
      }
      return userInfo;
    },
    currentUnitId() {
      var _this$user;
      return ((_this$user = this.user) === null || _this$user === void 0 || (_this$user = _this$user.userInfo) === null || _this$user === void 0 ? void 0 : _this$user.unitId) || Cookies.get("unitId") || "";
    },
    isAdministrator() {
      let {
        unitId,
        isAdmin,
        isFounder
      } = this.user.userInfo;
      return unitId && (isAdmin === "T" || isFounder === "T");
    },
    timer() {
      return dayjs().locale(this.language === "en-US" ? "en" : "zh-cn").format(this.language === "en-US" ? "MMMM YYYY" : $t("k9k7n88", "YYYY年MM月"));
    },
    /** Flat list of all apps across all groups (computed from groupedApps) */
    allAppList() {
      return Object.values(this.groupedApps).flat();
    },
    /** App groups sorted in design-spec order */
    orderedGroups() {
      const score = g => {
        const ci = GROUP_CODE_ORDER.indexOf(g.code);
        if (ci >= 0) return ci;
        const ni = GROUP_NAME_ORDER.findIndex(n => g.name && g.name.includes(n));
        if (ni >= 0) return GROUP_CODE_ORDER.length + ni;
        return 999;
      };
      return [...this.allGroups].sort((a, b) => score(a) - score(b));
    },
    /** Groups visible for the current active tab (with search filtering) */
    visibleGroups() {
      let groups;
      if (this.active === "ALL" || this.active === "FAVORITES") {
        groups = this.orderedGroups;
      } else {
        groups = this.orderedGroups.filter(g => g.id === this.active);
      }
      if (this.searchKeyword) {
        return groups.filter(g => this.getFilteredApps(g.id).length > 0);
      }
      return groups;
    },
    /** Apps returned by backend favorites, in backend order. */
    favApps() {
      return this.favoriteApps;
    },
    favoriteCount() {
      return this.backendFavoriteCount;
    },
    /** favApps filtered by search keyword */
    filteredFavApps() {
      if (!this.searchKeyword) return this.favApps;
      const kw = this.searchKeyword.toUpperCase();
      return this.favApps.filter(a => a.name && a.name.toUpperCase().includes(kw) || a.code && a.code.toUpperCase().includes(kw));
    },
    /** Whether to show the favorites quick row (全部 tab, has favs, no search) */
    showFavQuickRow() {
      return this.active === "ALL" && this.favoriteCount > 0 && !this.searchKeyword;
    },
    /** CSS grid class for non-Oracle group sections */
    gridClass() {
      if (this.isMobile) {
        return "grid-cols-2 gap-3";
      }
      return this.isBigFlex ? "grid-cols-[repeat(auto-fill,minmax(240px,1fr))] gap-5" : "grid-cols-[repeat(auto-fill,minmax(130px,1fr))] gap-5";
    },
    // 移动端固定使用双列详情卡片，PC 端继续沿用用户切换的大/小卡片偏好。
    showDetailCards() {
      return this.isMobile || this.isBigFlex;
    },
    // Oracle 特色大卡片只在 PC 大卡片模式展示，移动端按参考图降级为普通双列详情卡片。
    showOracleBento() {
      return !this.isMobile && this.isBigFlex;
    }
  },
  methods: {
    /** Returns true if the group is the Oracle Hospitality group */
    isOracleGroup(group) {
      return group.code === "OPERA" || group.name && group.name.includes("Oracle Hospitality");
    },
    /** Returns apps for a group filtered by search keyword */
    getFilteredApps(groupId) {
      const apps = this.groupedApps[groupId] || [];
      if (!this.searchKeyword) return apps;
      const kw = this.searchKeyword.toUpperCase();
      return apps.filter(a => a.name && a.name.toUpperCase().includes(kw) || a.code && a.code.toUpperCase().includes(kw));
    },
    /** Split Oracle group into OPERA for China big card + others */
    getOracleSplit(groupId) {
      const apps = this.getFilteredApps(groupId);
      const idx = apps.findIndex(a => a.name && a.name.includes("OPERA for China"));
      return {
        opera: idx >= 0 ? apps[idx] : null,
        others: idx >= 0 ? apps.filter((_, i) => i !== idx) : apps
      };
    },
    /** Count of visible apps for a group (respects search) */
    getGroupAppCount(groupId) {
      return this.getFilteredApps(groupId).length;
    },
    isFav(id) {
      return this.favorites.includes(id);
    },
    /** Inline style for normal (white-background) card star icon */
    favIconStyle(id) {
      return this.isFav(id) ? {
        "font-variation-settings": '"FILL" 1, "wght" 600, "GRAD" 0, "opsz" 24',
        color: "var(--secondary, #d4a017)"
      } : {};
    },
    /** Inline style for Oracle big card star icon */
    operaFavStyle(id) {
      return this.isFav(id) ? {
        "font-variation-settings": '"FILL" 1, "wght" 400, "GRAD" 0, "opsz" 24',
        color: "var(--secondary, #785a1a)"
      } : {
        color: "rgba(255,255,255,0.4)"
      };
    },
    applyFavoriteResult(retVal) {
      const normalized = normalizeFavorites(retVal);
      this.favorites = normalized.ids;
      this.favoriteApps = normalized.apps;
      this.backendFavoriteCount = normalized.favoriteCount;
    },
    async toggleFav(app) {
      if (this.isFavoriteSaving || !app || !app.id) return;
      const prevFavorites = this.favorites.slice();
      const prevFavoriteApps = this.favoriteApps.slice();
      const prevFavoriteCount = this.backendFavoriteCount;
      const nextFavorites = toggleFavorite(app.id, this.favorites);
      this.favorites = nextFavorites;
      // 乐观更新收藏展示，保存失败时按接口规则回滚，避免继续展示旧本地缓存。
      this.favoriteApps = this.buildFavoriteApps(nextFavorites);
      this.backendFavoriteCount = this.favoriteApps.length;
      this.isFavoriteSaving = true;
      try {
        const appIds = getVisibleFavoriteIds(nextFavorites, this.allAppList);
        const {
          data: {
            result,
            retVal,
            msg
          }
        } = await saveCurrentAppFavorites(appIds);
        if (result === 0) {
          this.applyFavoriteResult(retVal);
        } else {
          this.favorites = prevFavorites;
          this.favoriteApps = prevFavoriteApps;
          this.backendFavoriteCount = prevFavoriteCount;
          if (msg) this.$Message.error(msg);
        }
      } catch (e) {
        this.favorites = prevFavorites;
        this.favoriteApps = prevFavoriteApps;
        this.backendFavoriteCount = prevFavoriteCount;
      } finally {
        this.isFavoriteSaving = false;
      }
    },
    buildFavoriteApps(ids) {
      const currentApps = new Map(this.allAppList.map(app => [app.id, app]));
      const backendApps = new Map(this.favoriteApps.map(app => [app.id, app]));
      // 优先使用当前可见应用信息，后端返回的收藏应用作为保存前的短暂兜底展示。
      return ids.map(id => currentApps.get(id) || backendApps.get(id)).filter(Boolean);
    },
    async loadFavorites() {
      try {
        const {
          data: {
            result,
            retVal
          } = {}
        } = await getCurrentAppFavorites();
        if (result === 0) {
          this.applyFavoriteResult(retVal);
        }
      } catch (e) {
        // 收藏接口异常时不读取旧本地缓存，避免多端收藏状态重新分叉。
      }
    },
    onTabsScroll() {
      this.checkTabsOverflow();
    },
    checkTabsOverflow() {
      this.$nextTick(() => {
        const el = this.$refs.tabsRef;
        if (!el) return;
        this.showFadeLeft = el.scrollLeft > 1;
        this.showFadeRight = el.scrollLeft + el.clientWidth < el.scrollWidth - 1;
      });
    },
    /** 左右按钮只移动标签滚动容器，不改变当前筛选或应用分组数据。 */
    scrollTabs(direction) {
      const el = this.$refs.tabsRef;
      if (!el) return;
      const distance = Math.max(160, Math.floor(el.clientWidth * 0.6));
      el.scrollBy({
        left: direction === "left" ? -distance : distance,
        behavior: "smooth"
      });
      window.setTimeout(() => this.checkTabsOverflow(), 220);
    },
    setActive(id) {
      this.active = id;
      this.$nextTick(() => {
        if (this.$refs.contentArea) {
          this.$refs.contentArea.scrollTop = 0;
        }
      });
    },
    choice(app) {
      openApp(this, app);
    },
    openAppManager() {
      this.$router.push({
        name: "app-mamage"
      });
    },
    async getAppLists() {
      this.isAppListLoaded = false;
      try {
        const {
          data: {
            result,
            retVal
          }
        } = await getAppList();
        if (result === 0) {
          const grouped = {};
          retVal.appGroups.forEach(g => {
            grouped[g.id] = retVal.apps.filter(a => a.groupId === g.id);
          });
          this.$set(this, "groupedApps", grouped);
          this.allGroups = retVal.appGroups;
          // 应用列表加载完成后，用当前可见应用信息刷新收藏卡片，保证图标、名称等字段与工作台一致。
          this.favoriteApps = this.buildFavoriteApps(this.favorites);
        }
      } finally {
        // 接口完成后再允许空状态渲染，避免初始空数组被误判为没有应用。
        this.isAppListLoaded = true;
        this.$nextTick(() => this.checkTabsOverflow());
      }
    },
    async change(data, list) {
      if (!data || !data.moved) return;
      const {
        element,
        newIndex,
        oldIndex
      } = data.moved;
      const toAppIdIndex = oldIndex > newIndex ? newIndex + 1 : newIndex - 1;
      if (toAppIdIndex < 0 || toAppIdIndex >= list.length) return;
      const toAppId = list[toAppIdIndex].id;
      const {
        data: {
          result,
          msg
        }
      } = await editCustomAppOrder({
        fromAppId: element.id,
        toAppId
      });
      if (result !== 0) {
        this.$Message.error(msg);
        this.getAppLists();
      }
    },
    /** Toggle app card size and persist the user's browser-level view preference. */
    changeFlex() {
      this.isBigFlex = !this.isBigFlex;
      setMgtViewIsBig(this.isBigFlex);
    },
    async openAppMarket() {
      this.hideAppMarketTooltip();
      openApp(this, {
        code: "DSPLAT",
        isThird: "T"
      });
    },
    /** 点击应用市场会打开新窗口；先销毁 Tooltip，避免移动端返回页面后浮层常驻。 */
    hideAppMarketTooltip() {
      if (document.activeElement && typeof document.activeElement.blur === "function") {
        document.activeElement.blur();
      }
      this.showAppMarketTooltip = false;
    },
    /** 鼠标离开后再恢复 Tooltip，防止返回页面时悬停状态立即重新打开。 */
    restoreAppMarketTooltip() {
      this.$nextTick(() => {
        this.showAppMarketTooltip = true;
      });
    },
    dragend(event) {
      event.preventDefault();
    },
    // ── Stats / modal helpers (keep for WeekInDetail / WeekInAreaChars) ──

    getTimer(type) {
      let timeMap = {
        week: weekStartAndEnd(),
        month: monthStartAndEdn(),
        lastMonth: [dayjs().subtract(1, "month").startOf("month").format("YYYY-MM-DD"), dayjs().subtract(1, "month").endOf("month").format("YYYY-MM-DD")]
      };
      return timeMap[type];
    },
    async getLoginCountTop10() {
      let unitId = Cookies.get("unitId");
      if (!unitId) return;
      let type = this.statisticType;
      let [startDate, endDate] = this.getTimer(type);
      let {
        data: {
          retVal,
          result
        }
      } = await loginCountTop10({
        unitId,
        startDate,
        endDate
      });
      if (result === 0) {
        this.listTop10 = retVal;
      }
    },
    async openModal(type) {
      this.openModalHandler(type);
    },
    openModalHandler: throttle(async function (type) {
      let {
        unitId,
        unitName
      } = this.identityInfo;
      let [startDate, endDate] = this.getTimer(this.statisticType);
      let paramMap = {
        userDetailRef: null,
        weekInDetailRef: unitId,
        weekInAreaCharsRef: {
          orgId: unitId,
          startDate,
          endDate,
          depName: unitName
        }
      };
      this.$refs[type].open(paramMap[type], STATISTIC_LABEL[this.statisticType]);
    }, 1000, {
      leading: true,
      trailing: false
    }),
    /** 窗口宽度变化会改变标签溢出状态，需要同步刷新左右滚动按钮。 */
    handleTabsResize: throttle(function () {
      this.checkTabsOverflow();
    }, 200, {
      leading: true,
      trailing: true
    }),
    setstatisticType(value) {
      this.statisticType = value;
      this.getLoginCountTop10();
    },
    async getUnit() {
      let {
        data
      } = await getUnitInfo();
      let {
        retVal,
        result
      } = data;
      if (result === 0) {
        let {
          approved
        } = retVal;
        retVal.approvedStatus = [{
          icon: "ios-information-circle",
          text: $t("fsi133", "未认证"),
          color: "#8490A2",
          img: wrzImg
        }, {
          icon: "ios-loading",
          text: $t("dxb9y3", "审核中"),
          color: "#0052D9",
          img: shzImg
        }, {
          icon: "ios-close-circle",
          text: $t("bzrcwb4", "审核失败"),
          color: "#E34D59",
          img: wtgImg
        }, {
          icon: "ios-checkmark-circle-outline",
          text: $t("efw273", "已认证"),
          color: "#0DAC67",
          img: yrzImg
        }][approved];
        this.unit = retVal;
      }
    },
    onSuccessUpdate() {
      // placeholder
    },
    openNewWindow(link) {
      try {
        const newWindow = window.open(link, "_blank");
        if (!newWindow) this.openWithAnchor(link);
      } catch (e) {
        this.openWithAnchor(link);
      }
    },
    openWithAnchor(link) {
      const a = document.createElement("a");
      a.href = link;
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    async getServiceInterconnectionLink() {
      let {
        data: {
          result,
          retVal
        }
      } = await generateFwhlAuthCode();
      if (result === 0) {
        this.fwhlCode = retVal;
      }
      return retVal;
    },
    async openChangeLog() {
      let {
        data = "origin/release/2.0.0.1"
      } = await version();
      // eslint-disable-next-line no-unused-vars
      let vs = data.split("/").at(-1);
      let tag = `${vs}`;
      let link = `https://help.ihotel.cn/#/detail?c=JCYFB&v=IWORK${tag}`;
      window.open(link);
    }
  },
  async mounted() {
    this.loadFavorites();
    this.getUnit();
    this.getAppLists();
    this.getLoginCountTop10();
    window.addEventListener("resize", this.handleTabsResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleTabsResize);
    if (this.handleTabsResize.cancel) {
      this.handleTabsResize.cancel();
    }
  },
  activated() {
    this.loadFavorites();
  },
  watch: {
    currentUnitId() {
      this.loadFavorites();
    }
  }
};